import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useAuth } from "@/context/AuthContext";

export const publicName = (p) => `${(p.last_name || "").toUpperCase()} ${p.first_name || ""}`.trim();
export const publicYears = (p) => {
  if (p.living) return "";
  const b = p.birth_year ? `${p.birth_year_approx ? "vers " : ""}${p.birth_year}` : "";
  const d = p.death_year ? `${p.death_year_approx ? "vers " : ""}${p.death_year}` : "";
  return b || d ? `${b || "?"}${d ? ` – ${d}` : ""}` : "";
};

export const PublicPersonList = ({ clanKey }) => {
  const { API } = useAuth();
  const [list, setList] = useState(null);
  useEffect(() => {
    axios.get(`${API}/public/persons`, { params: { clan_key: clanKey }, timeout: 20000 })
      .then(r => setList(r.data)).catch(() => setList([]));
  }, [API, clanKey]);
  if (!list) return <div className="p-6 text-center text-[#6E5B4F]" data-testid="public-list-loading">Chargement…</div>;
  return (
    <section className="mb-10" data-testid="public-person-list">
      <div className="label-uppercase text-[#6E5B4F] mb-4">{list.length} personnes recensées</div>
      {list.length === 0 ? (
        <p className="heritage-card p-6 text-[#6E5B4F]">Aucune fiche publique pour le moment.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
          {list.map(p => (
            <Link key={p.id} to={`/persons/${p.id}`} className="heritage-card p-4 hover:bg-[#F0E6D8] transition-colors" data-testid={`public-person-${p.id}`}>
              <div className="font-serif-heritage text-lg text-[#261911]">{publicName(p)}</div>
              <div className="text-xs text-[#6E5B4F]">{publicYears(p) || (p.living ? "" : "date inconnue")}</div>
            </Link>
          ))}
        </div>
      )}
    </section>
  );
};

export default PublicPersonList;
